import { useApi } from '@/api';
import { Link, VaultName } from '@/components';
import {
  CryptoIcon,
  CurrencyValue,
  Flex,
  PercentageValue,
  useTableProps,
  DataTable,
  RelativeDateTime,
  EmptyBox
} from '@blockanalitica/ui';
import { TableColumn } from '@blockanalitica/ui/package/types/src/components/molecules/DataTable';

export default function GroupsTable() {
  const { sorting, pagination } = useTableProps({
    pageSize: 10,
    initialSorting: '-ilk',
    filtersDebounceTime: 50
  });
  const [data, error] = useApi({
    url: '/at-risk/cdps/',
    queryParams: {
      p: pagination.currentPage,
      p_size: pagination.pageSize,
      order: sorting.currentSorting
    }
  });

  if (error) {
    throw error;
  }

  if (data && data['results'].length > 0) {
    const columns: TableColumn[] = [
      {
        header: '',
        getCell: (row) => (
          <>
            {row.ilk} <CryptoIcon name={row.collateral_symbol} size="0" />
          </>
        ),
        cellAlign: 'flex-start',
        headerAlign: 'flex-start'
      },
      {
        header: 'CDP',
        getCell: (row) => (
          <VaultName iconSize={'4'} cdp={row.cdp} urn={row.urn} />
        ),
        cellAlign: 'flex-start',
        headerAlign: 'flex-start',
        sortingField: 'cdp'
      },

      {
        header: 'Liquidation Price',
        getCell: (row) => (
          <CurrencyValue
            value={row.liquidation_price}
            options={{ notation: 'standard', currency: 'USD' }}
          />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'liquidation_price'
      },
      {
        header: ' CR',
        getCell: (row) => (
          <PercentageValue value={row.collateralization_ratio} />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'collateralization_ratio'
      },
      {
        header: (
          <Flex
            display="flex"
            flexDirection="row"
            alignItems="center"
            gap="3xs">
            Debt
            <CryptoIcon name="DAI" size="0" />
          </Flex>
        ),
        getCell: (row) => (
          <CurrencyValue value={row.debt} options={{ notation: 'compact' }} />
        ),
        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'debt'
      },
      {
        header: 'Latest Activity',
        getCell: (row) => <RelativeDateTime value={row.datetime} />,

        cellAlign: 'flex-end',
        headerAlign: 'flex-end',
        sortingField: 'datetime'
      }
    ];

    return (
      <DataTable
        rows={data['results']}
        rowLinkProps={{
          to: (row) => `/collateral/core/${row.ilk}/cdps/${row.urn}/`,
          // @ts-ignore
          linkComponent: Link
        }}
        columns={columns}
        getKey={(row) => row.urn}
        sorting={sorting}
        pagination={{
          ...pagination,
          totalRecords: data.count
        }}
      />
    );
  }
  return <EmptyBox message="No CDPs at Risk" />;
}
